import type { UseXmppStatusReturn, UseXmppStatusEnum } from '../types'
import { useState, readonly, useOnline, watch, createSharedComposable } from '#imports'

export const useXmppStatus = createSharedComposable((): UseXmppStatusReturn => {
    const online = useOnline()

    const status = useState<UseXmppStatusEnum>('xmppStatus', () => online.value ? 'online' : 'offline')
    let debouncer: any = null

    if (import.meta.client) {
        watch(online, (online) => {
            if (online) {
                setStatus('online')
            }
            else {
                setStatus('offline')
            }
        })
    }

    function setStatus(value: UseXmppStatusEnum) {
        if (value === 'online') { // Set status as online asap and clear the debounce
            if (debouncer) {
                clearTimeout(debouncer)
            }
            status.value = 'online'

            return
        }

        if (debouncer) {
            clearTimeout(debouncer)
        }

        // Debounce since Firefox fires the onclose() method and waits for the response before reloading pages and user navigation changes.
        // Debounce since iOS Safari/Chrome stops all connections when the users changes apps (Bankid etc) and the connection message would show when coming back to the site.
        debouncer = setTimeout(() => {
            status.value = value
        }, 1500)
    }

    return {
        status: readonly(status),
        setStatus,
    }
})
